import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de poids des métaux - Calculez le poids du fer, de l'acier et de l'acier inoxydable";
const DESCRIPTION =
  "Calculatrice de poids des métaux - Calculez le poids du fer, de l'acier et de l'acier inoxydable. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "metal weight, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/metal-weight/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Calculatrice de poids des métaux",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
];

const DENSITIES = {
  steel: { value: 7.85, name: "Acier au carbone" },
  stainless: { value: 8.0, name: "Acier inoxydable" },
  aluminium: { value: 2.7, name: "Aluminium" },
  copper: { value: 8.96, name: "Cuivre" },
};

const PROFILE_TYPES = {
  plate: "Plaque / Tôle",
  round: "Barre ronde",
  pipe: "Tuyau / Tube",
  square: "Barre carrée",
  rectangular: "Barre rectangulaire",
};

function MetalWeightCalculator() {
  const [profileType, setProfileType] = useState("plate");
  const [material, setMaterial] = useState("steel");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState(null);
  const [error, setError] = useState("");

  const calculateWeight = () => {
    try {
      setError("");
      const lengthVal = parseFloat(length);
      const widthVal = parseFloat(width);
      const heightVal = parseFloat(height);
      const density = DENSITIES[material].value;

      if (isNaN(lengthVal) || isNaN(widthVal) || isNaN(heightVal)) {
        setError("Veuillez entrer des valeurs valides");
        setWeight(null);
        return;
      }

      let volume = 0;
      if (profileType === "plate") {
        volume = lengthVal * widthVal * heightVal;
      } else if (profileType === "round") {
        volume = Math.PI * (widthVal / 2) ** 2 * lengthVal;
      } else if (profileType === "pipe") {
        const outerDiameter = widthVal;
        const wallThickness = heightVal;
        volume = Math.PI * ((outerDiameter / 2) ** 2 - ((outerDiameter - 2 * wallThickness) / 2) ** 2) * lengthVal;
      } else {
        volume = lengthVal * widthVal * heightVal;
      }

      const weightValue = volume * density;
      setWeight(weightValue.toFixed(2));
    } catch (err) {
      setError("Erreur lors du calcul");
      setWeight(null);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer le poids des métaux</h2>
                <p>
                  Pour calculer le poids d'un métal, vous devez entered les dimensions (longueur, largeur, hauteur/épaisseur) et sélectionner le type de matériau. La calculatrice détermine le volume et multiplie par la densité réelle du matériau pour obtenir le poids.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group">
                      <label>Type de profil</label>
                      <select
                        className="form-control"
                        value={profileType}
                        onChange={(e) => setProfileType(e.target.value)}
                      >
                        {Object.entries(PROFILE_TYPES).map(([key, label]) => (
                          <option key={key} value={key}>
                            {label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br />
                    <div className="form-group">
                      <label>Matériau</label>
                      <select
                        className="form-control"
                        value={material}
                        onChange={(e) => setMaterial(e.target.value)}
                      >
                        {Object.entries(DENSITIES).map(([key, { name }]) => (
                          <option key={key} value={key}>
                            {name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Longueur (cm)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="Longueur"
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Largeur (cm)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="Largeur"
                        value={width}
                        onChange={(e) => setWidth(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Hauteur/Épaisseur (cm)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="Hauteur"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="form-control"
                        style={{ width: "150px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={calculateWeight}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      weight !== null && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Poids : {weight} grammes
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <br />
    </div>
  );
}
export default MetalWeightCalculator;
